import React from 'react';
import BaseComponent from '../../common/BaseComponent/BaseComponent';

import styles from './LawBanner.scss';
import closeImg from './img/x-close.png'
import {ContextDataStore} from "../../common/helpers/HelperGlobalDataStore";
import HelperCookie from "../../common/helpers/HelperCookie";
import {__t} from '../../common/lang/text-resource';


class LawBanner extends BaseComponent {

	acceptLawBanner = e => {
		if (e.target.tagName.toLowerCase() !== 'a') {
			HelperCookie.setCookie('sh_hdgbar', 2, 800)
			this.eventRaise('LawBannerAccepted');
			const fixedTotals = document.getElementsByClassName('js-cart-fixed-total');
			if (fixedTotals.length > 0) {
				fixedTotals[0].style.bottom = 0;
			}
			this.forceUpdate();
		}
	};

	render() {
		const hasLawCookie = HelperCookie.getCookie('sh_hdgbar') !== '';
		if (hasLawCookie) {
			return null;
		}
		return (
		  <div data-test="js-law-banner" className={`${styles.container} preload_remove`}
			   onClick={this.acceptLawBanner}>
			  <table>
				  <tbody>
				  <tr>
					  <td>
						  <p>
							  {__t('този-сайт-използва-бисквитки-тъй-като-те-са-важни29318d')}&nbsp;
							  <a href="/web-hosting-page-terms-and-agreements.php#cookie_policy">
								  {__t('Политика за използване на бисквитки.')}
							  </a>
						  </p>
					  </td>
					  <td>
						  <img src={closeImg} alt={__t("Затвори")}/>
					  </td>
				  </tr>
				  </tbody>
			  </table>
		  </div>
		);
	}
}


// React Context binding
LawBanner.contextType = ContextDataStore;

export default LawBanner;